import { useFormContext } from 'react-hook-form';
import type { TLocalize } from '@hooks/use-localize';
import type { IHistoryDemographicsFormValues, IHistoryDemographicsModel } from '@/types/history/history-demographics';
import FieldError from '@components/field-error';

interface IContactSectionProps {
    model: IHistoryDemographicsModel;
    t: TLocalize;
}

/** Emergency contact name / phone / relationship. */
const ContactSection = ({ model, t }: IContactSectionProps) => {
    const {
        register,
        formState: { errors },
    } = useFormContext<IHistoryDemographicsFormValues>();

    return (
        <>
            <div className='section-heading'>Contact</div>

            <div className="form-group">
                <label className="control-label col-xs-12">
                    {t('DashLabel_EmergencyContactName', 'Emergency Contact Name')}:
                    <FieldError message={errors.emergencyContact?.message} />
                </label>
                <div className="col-xs-12 col-md-8">
                    <input className="form-control" maxLength={32} {...register('emergencyContact')} />
                </div>
            </div>

            <div className="form-group">
                <label className="control-label col-xs-12">
                    {t('DashLabel_EmergencyContactPhone', 'Emergency Contact Phone')}:
                    <FieldError message={errors.emergencyContactPhone?.message} />
                </label>
                <div className="col-xs-12 col-md-8">
                    <input className="form-control" {...register('emergencyContactPhone')} />
                </div>
            </div>

            <div className="form-group">
                <label className="control-label col-xs-12">
                    {t('DashLabel_RelationshipWithEmergencyContact', 'Relationship with Emergency Contact')}:
                    <FieldError message={errors.emergencyContactRelationship?.message} />
                </label>
                <div className="col-xs-12 col-md-8">
                    <select className="form-control" {...register('emergencyContactRelationship')}>
                        <option value="">{t('DashLabel_PleaseSelect', 'Please Select')}</option>
                        {model.relationshipToContactOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
        </>
    );
};

export default ContactSection;
